export const Sources = {
    TIMESTREAM: 'timestream',
    S3Athena: 's3Athena'
};
